import { useState, useEffect } from "react";
import "./QuestionSettingsScore.css";
import { QuestionSelector } from "../question-selector/QuestionSelector";
import { Question, QuestionType, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import toast from "react-hot-toast";
import { toastFail } from "../../config";
import { MySwitch } from "../form-widgets/MySwitch";

type QuestionSettingsScoreProps = {
    question: Question;
    onChange: (question: Question) => void;
}

export const QuestionSettingsScore = ({question, onChange} : QuestionSettingsScoreProps) => {

    const [settings, setSettings] = useState<any | null>(JSON.parse(question.settings));
    const [type, setType] = useState<QuestionType>(question.type);
    const [required, setRequired] = useState<boolean>(question.required);

    useEffect(() => {
        setSettings(JSON.parse(question.settings));
        setRequired(question.required);
        setType(question.type);
    }, [question]);

    const handleTypeChange = async (value: string) => {
        console.log("[QuestionSettingsScore/handleTypeChange] value: ", value);
    }

    const handleRequiredChange = async (checked: boolean) => {
        setRequired(checked);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required: checked,
            settings: JSON.stringify(settings),
            conditions: question.conditions
        }

        updateSettings(payload);
    }

    const handleSettingChange = async (e: any) => {
        console.log("[QuestionSettingsScore/handleSettingChange] e: ", e);

        let newSettings = {...settings};

        switch (e.target.name) {
            case "minScore":
                if (parseInt(e.target.value) > -1 && parseInt(e.target.value) <= settings.maxScore) {
                    newSettings = {...settings, [e.target.name]: parseInt(e.target.value)};
                }
                break;
            case "maxScore":
                if (parseInt(e.target.value) >= settings.minScore) {
                    newSettings = {...settings, [e.target.name]: parseInt(e.target.value)};
                }
                break;
            // case "rightLabelOn":
            // case "leftLabelOn":
            //     newSettings = {...settings, [e.target.name]: e.target.checked};
            //     break;
            default:
                newSettings = {...settings, [e.target.name]: e.target.value};
        }

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        updateSettings(payload)
    }

    const handleSwitchSettings = async (name: string, checked: boolean) => {
        console.log("[QuestionSettingsContact/handleSwitchSettings] name: ", checked);

        let newSettings = {...settings};

        switch (name) {
            case "rightLabelOn":
            case "leftLabelOn":
                newSettings = {...settings, [name]: checked};
                break;
            default:
                // nadad
        }

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        updateSettings(payload)
    }

    // have to send in the payload here due to react setting asyncs
    const updateSettings = async(payload: UpdateQuestionPayload) => {

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error updating question", toastFail);
            return;
        }

        // update UI
        onChange(newQuestion);
    }

    console.log("[QuestionSettingsScore] settings: ", settings);

    return (        
        <>
            <div className="question-settings-score">
                {/* <QuestionSelector defaultValue={type} onChange={handleTypeChange}/>

                <div className="question-setting-divider">{}</div> */}

                <div className="question-setting">
                    <div className="question-setting-label">
                        Required
                    </div>
                    <div className="question-setting-checkbox">
                        <MySwitch 
                            id="required"
                            checked={required}
                            onChange={handleRequiredChange}
                        />
                    </div>
                </div>

                <div className="question-setting-stack">
                    <div className="question-setting-stack-top">
                        <div className="question-setting-label">
                            Min Score
                        </div>
                        <div className="question-setting-number">
                            <input 
                                type="number"
                                name="minScore"
                                value={settings?.minScore}
                                onChange={handleSettingChange}
                                data-testid="minScore"
                            />
                        </div>
                    </div>
                </div>

                <div className="question-setting-stack">
                    <div className="question-setting-stack-top">
                        <div className="question-setting-label">
                            Max Score
                        </div>
                        <div className="question-setting-number">
                            <input 
                                type="number"
                                name="maxScore"
                                value={settings?.maxScore}
                                onChange={handleSettingChange}
                                data-testid="maxScore"
                            />
                        </div>
                    </div>
                </div>

                <div className="question-setting-stack">
                    <div className="question-setting-stack-top">
                        <div className="question-setting-label">
                            Left Label
                        </div>
                        <div className="question-setting-radio">
                            <MySwitch 
                                id="leftLabelOn"
                                checked={settings?.leftLabelOn}
                                onChange={(checked: boolean) => 
                                    handleSwitchSettings("leftLabelOn", checked)
                                }
                            />
                        </div>
                    </div>
                        
                    {settings?.leftLabelOn &&
                        <div className="question-setting-stack-bottom">
                            <input 
                                type="text"
                                name="leftLabel"
                                value={settings?.leftLabel}
                                onChange={handleSettingChange}
                                data-testid="leftLabel"
                            />
                        </div>
                    }

                </div>

                <div className="question-setting-stack">
                    <div className="question-setting-stack-top">
                        <div className="question-setting-label">
                            Right Label
                        </div>
                        <div className="question-setting-radio">
                            <MySwitch 
                                id="rightLabelOn"
                                checked={settings?.rightLabelOn}
                                onChange={(checked: boolean) => 
                                    handleSwitchSettings("rightLabelOn", checked)
                                }
                            />
                        </div>
                    </div>
                        
                    {settings?.rightLabelOn &&
                        <div className="question-setting-stack-bottom">
                            <input 
                                type="text"
                                name="rightLabel"
                                value={settings?.rightLabel}
                                onChange={handleSettingChange}
                                data-testid="rightLabel"
                            />
                        </div>
                    }

                </div>
            </div>
            
        </>
    )
}